import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledItemBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
  border-radius: 0.625rem;
  padding: 1rem;
`;

export const StyledItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledItemNumber = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  border-radius: 0.375rem;
  background-color: ${({ theme }) => theme?.token?.colorPrimary};
  color: ${COLORS.WHITE};
  ${pickThemeFontStyles('12', '16', 'BOLD')}
`;

export const StyledItemTitle = styled.span`
  ${pickThemeFontStyles('13', '18', 'BOLD')}
  color: ${COLORS.TEXT_PRIMARY};
  flex-grow: 1;
`;

export const StyledItemActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;
